var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useId } from "react";
import { IconButton, Tooltip } from "@folio/stripes/components";
import { useCallout } from "@folio/stripes/core";
import { useIntl } from "react-intl";
import { writeToClipboard } from "../utils/clipboard";
import css from "./CopyableId.module.css";
var EMPTY_VALUE = "-";
/**
 * Offers a line break after every hyphen. Unicode line breaking forbids a
 * break between a hyphen and a digit, so without it a UUID like
 * "33333333-3333-…" would not wrap at its hyphens at all. <wbr> is not part of
 * the selected/copied text.
 */
var withHyphenBreaks = function (value) {
    return value.split("-").map(function (segment, index, segments) { return (
    // eslint-disable-next-line react/no-array-index-key
    React.createElement(React.Fragment, { key: index },
        segment,
        index < segments.length - 1 && (React.createElement(React.Fragment, null,
            "-",
            React.createElement("wbr", null))))); });
};
/**
 * Read-only identifier with a copy-to-clipboard icon button next to it.
 * The value stays selectable text; the outcome of a copy is reported to the
 * user by a success or error callout.
 */
export var CopyableId = function (_a) {
    var value = _a.value;
    var formatMessage = useIntl().formatMessage;
    var callout = useCallout();
    var tooltipId = "copyable-id-".concat(useId());
    if (!value) {
        return React.createElement(React.Fragment, null, EMPTY_VALUE);
    }
    var copyLabel = formatMessage({ id: "ui-br-agency.copyableId.copy.label" });
    var handleCopy = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, writeToClipboard(value)];
                case 1:
                    _b.sent();
                    callout === null || callout === void 0 ? void 0 : callout.sendCallout({
                        type: "success",
                        message: formatMessage({ id: "ui-br-agency.copyableId.copy.success" }),
                    });
                    return [3 /*break*/, 3];
                case 2:
                    _a = _b.sent();
                    callout === null || callout === void 0 ? void 0 : callout.sendCallout({
                        type: "error",
                        message: formatMessage({ id: "ui-br-agency.copyableId.copy.error" }),
                    });
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    return (React.createElement("span", { className: css.copyableId },
        React.createElement("span", { className: css.value }, withHyphenBreaks(value)),
        React.createElement(Tooltip, { id: tooltipId, text: copyLabel }, function (trigger) { return (React.createElement(IconButton, { ref: trigger.ref, icon: "clipboard", size: "small", className: css.copyButton, onClick: handleCopy, "aria-label": copyLabel, "aria-labelledby": trigger.ariaIds.text })); })));
};
